import {Component, EventEmitter, Input, OnInit, Output, signal} from '@angular/core';
import {IncidentComment} from '../../classes/incidentcomment.class';
import {IncidentService} from '../../services/incident.service';
import {LocalStorage} from '../../storage.class';
import {User} from '../../classes/user.class';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {Settings} from "../../settings.class";
import {DatePipe} from "@angular/common";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {Nl2brPipe} from "../../pipes/nl2br.pipe";
import {SafeBgUrlPipe} from "../../pipes/safe-bg-url.pipe";

@Component({
    selector: 'app-incident-comment',
    templateUrl: './incident-comment.component.html',
    styleUrls: ['./incident-comment.component.scss'],
    imports: [
        DatePipe,
        MatIconButton,
        MatIcon,
        MatFormField,
        MatLabel,
        FormsModule,
        CdkTextareaAutosize,
        MatInput,
        Nl2brPipe,
        SafeBgUrlPipe,
        MatButton
    ]
})
export class IncidentCommentComponent implements OnInit {

    @Input() incidentComment: IncidentComment;

    @Output() uploadFiles = new EventEmitter<File[]>();

    @Output() deleted = new EventEmitter<IncidentComment>();

    @Output() placedComment = new EventEmitter<IncidentComment>();

    @Output() openFile = new EventEmitter<object>();

    url = Settings.API_ENDPOINT + 'file/';
    token = LocalStorage.getUserToken();

    readonly editing = signal<boolean>(false);

    readonly mayEdit = signal<boolean>(false);

    readonly saving = signal<boolean>(false);

    private user: User;

    constructor(private incidentService: IncidentService,
                private confirmDialog: ConfirmDialogService) {
    }

    ngOnInit(): void {
        this.user = LocalStorage.getUser();
        this.editing.set(!this.incidentComment.id);
        this.mayEdit.set(this.user.id === this.incidentComment.user_id || !this.incidentComment.user_id);
    }

    placeOrEditComment() {
        this.saving.set(true);
        this.incidentService.saveComment(this.incidentComment).then(comment => {
            if (!this.incidentComment.id) {
                this.incidentComment.id = comment.id;
                this.incidentComment.created_at = comment.created_at;
                this.placedComment.emit(this.incidentComment);
            }
            this.editing.set(false);
            this.saving.set(false);
        }, () => {
            this.saving.set(false);
        });
    }

    edit() {
        this.editing.set(true);
    }

    public uploadFile(event) {
        const files = event.srcElement.files;
        this.uploadFiles.emit(files);
    }

    deleteComment() {
        this.confirmDialog.confirm(
            'Verwijderen',
            `Weet u zeker dat u deze reactie van ${this.incidentComment?.user?.name} wilt verwijderen?`,
            'Verwijderen',
            'Behouden'
        ).then(() => {
            if (this.incidentComment.id) {
                this.incidentService.deleteComment(this.incidentComment.id).then(success => {
                    if (success) {
                        this.deleted.emit(this.incidentComment);
                    }
                });
            } else {
                this.deleted.emit(this.incidentComment);
            }
        }, () => {
        });
    }

}
